/**
 * @file_purpose  page for showing video portfolio contact form 
 * @author Sucheta Singha
 * @Date_Created 19-09-2024
 * @Date_Modified 19-09-2024
 */
import React, { useState, useEffect } from 'react'
import { useHistory, useParams, useLocation, Link } from 'react-router-dom'
import {
    CForm,
    CButton,
    CSpinner,
    CInputGroup
} from '@coreui/react'
import { ToastContainer, toast } from 'react-toastify';
import GeneralService from "src/apis/GeneralService";
import OtpInput from "react-otp-input";
import Constants from "src/Utility/Constants";
import RouteURL from "src/apis/ApiURL";
import VideoPortBanner from "../../../assets/icons/video_banner.png"
import VideoLogo from "../../../assets/icons/vid_logo.png"

export default function VideoPortfolioVerifyOTP() {
    const history = useHistory();
    const formData = new FormData();
    const [isButtonDisable, setIsButtonDisable] = useState(true);
    const [loader, setLoader] = useState(0);
    const [isTextFieldDisable, setIsTextFieldDisable] = useState(false);
    const [state, setState] = useState({
        otp: "",
        numInputs: 4,
        separator: "-",
        isDisabled: false,
        hasErrored: false,
        isInputNum: false,
        isInputSecure: false,
        minLength: 0,
        placeholder: "",
    })

    useEffect(() => { window.scrollTo(0, 0) }, [])

    const video_portfolio_email = localStorage.getItem('video_portfolio_email');
    const video_portfolio_name = localStorage.getItem('video_portfolio_name');
    const video_portfolio_phone = localStorage.getItem('video_portfolio_phone');
    const video_portfolio_country_code = localStorage.getItem('video_portfolio_country_code');

    useEffect(() => {
        let checkValues = Object.values(state["otp"]).every(item => item === true);
        if (checkValues == false && state["otp"].length == 4) setIsButtonDisable(false)
        else setIsButtonDisable(true)

    }, [state["otp"]])


    const handleOtpChange = (otp) => {
        setState({ otp: otp });

    };


    /* Validation Checking */
    const ValidateContactForm = (e) => {
        e.preventDefault();
        contactSubmitClick();
    }


    const contactSubmitClick = () => {
        setIsButtonDisable(true)
        setIsTextFieldDisable(true)
        setLoader(1);
        formData.append("name", video_portfolio_name ? video_portfolio_name : null);
        formData.append("phone_number", video_portfolio_phone ? video_portfolio_country_code + video_portfolio_phone : null);
        formData.append("email", video_portfolio_email ? video_portfolio_email : null);
        formData.append("page_details", "Video Portfolio");
        formData.append("otp", state.otp ? state.otp : null);


        GeneralService.apiPostCallFormDataRequestWithoutToken(RouteURL.videoPortfolioAddContact, formData)
            .then((res) => {
                setIsButtonDisable(false)
                setIsTextFieldDisable(false)
                if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                    history.push({
                        pathname: `/video-portfolio-details`,
                        state: { otp_verified_status: true, contact_id: res.data.contact_id }
                    });
                    localStorage.removeItem("video_portfolio_email");
                    localStorage.removeItem("video_portfolio_name");
                    localStorage.removeItem("video_portfolio_phone");
                    localStorage.removeItem("video_portfolio_country_code");
                    localStorage.setItem('video_portfolio_verify_otp', "1")
                    localStorage.setItem('video_portfolio_contact_id', res.data.contact_id)


                    setLoader(0);
                } else {
                    setIsButtonDisable(false)
                    setIsTextFieldDisable(false)
                    toast.error(res.message, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    setLoader(0);
                }
            })
            .catch((error) => {
                setIsButtonDisable(false)
                setIsTextFieldDisable(false)
                if (error.response.status === 401) {
                    console.log(error);

                }
            });



    }


    /**
      * @author Sucheta Singha
      * @Date_Created 20.09.2024
      * @Date_Modified 20.09.2024
      * @function sync
      * @functionName ResendOTPClick
      * @functionPurpose this function calling resend otp function.
      *
      * @functionParam {payload object:email,name}
      * 
      * @functionSuccess Success status and message.
      *
      * @functionError {Boolean} error error is there.
      * @functionError {String} message  Description message.
      */
    const ResendOTPClick = (e) => {
        setState({ otp: '' });
        let params = JSON.stringify({
            name: video_portfolio_name,
            email: video_portfolio_email,
        })
        GeneralService.apiPostCallRequestWithoutToken(RouteURL.videoPortfolioConatactEmailOTP, params).then(res => {
            if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                toast.success(res.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
            else {
                toast.error(res.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        }).catch(error => {
            console.log(error);
        })
    }

    const GoBackClick = (e) => {
        e.preventDefault();
        history.push({
            pathname: `/video-portfolio-contact`,
        });
    }

    // const sendHeight = () => {
    //     // Send the height of the iframe content to the parent page
    //     window.parent.postMessage(document.body.scrollHeight, '*');
    // }

    // // Send height initially and on content changes
    // window.addEventListener('load', sendHeight);
    // window.addEventListener('resize', sendHeight);

    // const observer = new MutationObserver(sendHeight);
    // observer.observe(document.body, { childList: true, subtree: true });


    const sendHeight = () => {
        // Send the height of the iframe content to the parent page
        window.parent.postMessage(document.body.scrollHeight, '*');
    };

    // Debounce function to limit the number of times sendHeight is called
    const debounce = (func, delay) => {
        let timer;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(func, delay);
        };
    };

    // Create debounced version of sendHeight
    const debouncedSendHeight = debounce(sendHeight, 100);

    // Send height initially and on content changes
    window.addEventListener('load', debouncedSendHeight);
    window.addEventListener('resize', debouncedSendHeight);

    // Observe changes in the DOM with a slight delay to ensure rendering is complete
    const observer = new MutationObserver(debouncedSendHeight);
    observer.observe(document.body, { childList: true, subtree: true });

    return (
        <>
            <body style={{ backgroundColor: "#fff" }}>

                {/* <div className="appoinment_hed">
                    <h4 className='mb-0'>
                        PLEASE ENTER YOUR VERIFICATION CODE SENT TO {video_portfolio_email}
                    </h4>
                    <CForm action="" method="post" className="form-horizontal">
                        {loader ?
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', width: '100%', marginTop: "10%" }}> <CSpinner
                                style={{ width: '4rem', height: '4rem', }}
                                color="danger"
                                variant="grow"
                                className="loader_z_index"
                            />
                            </div>
                            : ""}
                        <div className="booking_field">
                            <div className='row'>
                                <div className="col-md-12">
                                    <div className="verify_main">
                                        <CInputGroup className="verify_box">
                                            <OtpInput
                                                className="verify_box_inner"
                                                inputStyle="inputStyle"
                                                numInputs="4"
                                                isDisabled={state.isDisabled}
                                                hasErrored={state.hasErrored}
                                                errorStyle="error"
                                                onChange={handleOtpChange}
                                                // separator={<span>{state.separator}</span>}
                                                isInputNum={state.isInputNum}
                                                isInputSecure={state.isInputSecure}
                                                shouldAutoFocus
                                                value={state.otp}
                                                placeholder={state.placeholder}
                                            />
                                        </CInputGroup>
                                    </div>
                                </div>

                                <p> Not received the code? <span onClick={ResendOTPClick} style={{ cursor: 'pointer', color: '#5473FF' }} >Resend</span>
                                </p>


                            </div>

                        </div>


                        <div className="booking_btns_sec">
                            <div className="atten_sec1 col-12 text-center">
                                <CButton className="cancel" onClick={GoBackClick}
                                    style={{ background: isButtonDisable == true ? '#DFDFDF' : '#ABABAB', marginRight: 10 }}
                                ><i class="fa-solid fa-chevron-left"></i> Back</CButton>

                                <CButton className="save"
                                    onClick={ValidateContactForm}
                                    disabled={isButtonDisable ? true : false}
                                    style={{ background: isButtonDisable ? '#DFDFDF' : '#E84C3D' }}
                                >
                                    Submit
                                    <i class="fa-solid fa-angle-right right_save"></i>

                                </CButton>

                            </div>
                        </div>
                    </CForm>
                </div> */}



                <div className='video_portfolio_sec'>
                    <div className="video_portfolio_inn video_form_ht" style={{ backgroundImage: 'url(' + VideoPortBanner + ')' }}>
                        <div className='container'>
                            <div className='row justify-content-between'>
                                <div className='col-sm-12 col-xxl-4 col-xl-4 col-lg-4 col-md-6'>
                                    <div className='video_portfolio_inn_lt'>
                                        <div className='video_portfolio_inn_lt_logo'>
                                            <img src={VideoLogo} alt='' />
                                            <p>ISO/IEC 27001:2013</p>
                                        </div>

                                        <div className='video_portfolio_inn_btm'>
                                            <h3>Welcome</h3>
                                            <p>Greetings, fellow gamers! We are thrilled to welcome you to our game development company, where we turn your gaming <br />dreams into reality.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-6'>
                                    <div className='video_portfolio_form_sec'>
                                        <div className='row'>
                                            <div className='col-sm-12'>
                                                <h4 className='video_form_hed'> PLEASE ENTER YOUR VERIFICATION CODE SENT TO {video_portfolio_email}</h4>

                                                <CForm action="" method="post" className="form-horizontal">
                                                    {loader ?
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', width: '100%', marginTop: "10%" }}> <CSpinner
                                                            style={{ width: '4rem', height: '4rem', }}
                                                            color="danger"
                                                            variant="grow"
                                                            className="loader_z_index"
                                                        />
                                                        </div>
                                                        : ""}
                                                    <div className="otp_field">
                                                        <h6>OTP</h6>
                                                        <div className='row'>
                                                            <div className="col-md-12">
                                                                <div className="otpverify_main">
                                                                    <CInputGroup>
                                                                        <OtpInput
                                                                            className="verify_box_inner"
                                                                            inputStyle="inputStyle"
                                                                            numInputs="4"
                                                                            isDisabled={state.isDisabled}
                                                                            hasErrored={state.hasErrored}
                                                                            errorStyle="error"
                                                                            onChange={handleOtpChange}
                                                                            // separator={<span>{state.separator}</span>}
                                                                            isInputNum={state.isInputNum}
                                                                            isInputSecure={state.isInputSecure}
                                                                            shouldAutoFocus
                                                                            value={state.otp}
                                                                            placeholder={state.placeholder}
                                                                            onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                                                        />
                                                                    </CInputGroup>
                                                                </div>
                                                            </div>



                                                        </div>

                                                    </div>
                                                    <p className='otp_resend'> Not received the code? <span onClick={ResendOTPClick} style={{ cursor: 'pointer', color: '#fff' }} >Resend</span>
                                                    </p>



                                                    <div className="booking_btns_sec">
                                                        <div className="atten_sec1 col-12 text-center">
                                                            <CButton className="cancel" onClick={GoBackClick}
                                                                style={{ background: isButtonDisable == true ? '#DFDFDF' : '#ABABAB', marginRight: 10 }}
                                                            ><i class="fa-solid fa-chevron-left"></i> Back</CButton>

                                                            <CButton className={` ${(isButtonDisable == false) ? 'save opacity_mild' : 'save '}`}
                                                                onClick={ValidateContactForm}
                                                                disabled={isButtonDisable ? true : false}

                                                            >
                                                                Verify


                                                            </CButton>

                                                        </div>
                                                    </div>
                                                </CForm>


                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </body>
        </>
    )
}





